export default __webpack_public_path__ + "static/media/head02_en_pc@2x.db70692a.png";